import { useEffect } from 'react';
import { Message, Icon } from 'semantic-ui-react';
import ReactGA from 'react-ga4';

import ProjectSummaryData from './components/ProjectSummaryData';
import { useProjectContext } from '~/hooks/providers/ProjectContextProvider';
import ErrorDialog from './components/ErrorDialog';
import { useTutorials } from '~/hooks/providers/TutorialProvider';
import { usePermissions } from '~/requests/permissions/usePermissions';
import { DealStates } from '~/constants';
import './styles.scss';

export default function ProjectSummary() {
  const {
    project,
    projectState,
    projectDisplayValues,
    projectState: { dealState },
    projectErrors,
    projectAutopricing
  } = useProjectContext();
  const { permissions } = usePermissions();
  const { setTutorialContext } = useTutorials() as any;

  ReactGA.send({
    hitType: 'pageview',
    page: '/project/id/review',
    title: `${project?.name} | Conductor Solar`
  });
  document.title = `${project?.name} | Conductor Solar`;

  useEffect(() => {
    setTutorialContext({
      page: 'projectSummary',
      data: {
        permissions,
        projectState,
        dealState
      }
    });
  }, [permissions, projectState, dealState]);

  return (
    <div className="container">

      {projectState.isEpcOperating && (
        <Message info icon style={{ marginBottom: '12px', borderRadius: '4px' }}>
          <Icon name="info circle" style={{ fontSize: '32px', color: '#07475d' }} />
          <Message.Content>
            <Message.Header style={{ marginBottom: '0', fontSize: '16px' }}>
              Operating Project
            </Message.Header>
            <span style={{ fontSize: '14px' }}>Please note that some data fields are based on initial contract terms (e.g. offtake and site lease) while others are based on current values (e.g. system production).</span>
          </Message.Content>
        </Message>
      )}

      {projectState.isRejected && projectState.dealState < DealStates.IN_REVIEW && <ErrorDialog />}

      <ProjectSummaryData
        project={project}
        values={projectDisplayValues}
        projectState={projectState}
        projectErrors={projectErrors}
        projectAutopricing={projectAutopricing}
      />

    </div>
  );
};